import styled from 'styled-components';
import { SegmentedControl } from 'ui/segmentedControl';
import { spacing, Subtitle2 } from 'ui/theme';
import { Combinator } from 'modules/workflows/types';
import { DEFAULT_SEARCH_COMBINATOR } from 'modules/journey/components/FilterInputsList/FilterInputsList.constants';
import { useStartNodeContext } from '../StartNodeEditor.context';
import { COMBINATOR_TEXT, COMBINATOR_TEST_ID } from './EntryRules.constants';

export const CombinatorContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.half};
`;

const getOptions = (isReadOnly: boolean) =>
  Object.values(COMBINATOR_TEXT).map((opt) => ({
    ...opt,
    disabled: isReadOnly,
  }));

export const CombinatorSelect = () => {
  const { isReadOnly, nodeData, setNodeData } = useStartNodeContext();
  const { searchCombo = { combinator: DEFAULT_SEARCH_COMBINATOR, searchQueries: [] } } = nodeData;
  const { combinator } = searchCombo || {};

  const onSelect = (selected: Combinator) =>
    setNodeData({
      searchCombo: {
        ...searchCombo,
        combinator: selected,
      },
    });

  return (
    <CombinatorContainer data-test={COMBINATOR_TEST_ID}>
      <Subtitle2>Event must have</Subtitle2>
      <SegmentedControl
        data-test="filters-input-combinator-input"
        onSelect={onSelect}
        options={getOptions(isReadOnly)}
        optionMinWidth={spacing.x4}
        value={combinator}
      />
      <Subtitle2>of the following:</Subtitle2>
    </CombinatorContainer>
  );
};
